import { Component, input } from '@angular/core';
import { TankTypeEnum } from 'taxtank-core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tank-icon',
  imports: [CommonModule],
  templateUrl: './tank-icon.component.html',
  styleUrl: './tank-icon.component.scss'
})
export class TankIconComponent {
  tankType = input<TankTypeEnum>();
  inputClass = input<string>();
}
